export enum CustomHeaderTextKey {
  regOnBlurredPhoto = 'regOnBlurredPhoto',
}
